// src/redux/slices/library/author.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthorType } from "../../../types/Library";

const initialState: AuthorType = {
    fullname: "",
};

const authorSlice = createSlice({
    name: "author",
    initialState,
    reducers: {
        setAuthorData: (state, action: PayloadAction<AuthorType>) => ({
            ...state,
            ...action.payload,
        }),
        resetAuthorData: () => initialState,
    },
});

export const { setAuthorData, resetAuthorData } = authorSlice.actions;
export default authorSlice.reducer;
